import React, { useMemo } from "react";
import { motion } from "framer-motion";
import { getDirectControlMethods } from "../../lib/specsUtils";

const ECO_LABEL = {
  apple: "Apple Home",
  google: "Google Home",
  alexa: "Amazon Alexa",
  mixed: "Vegyes / nincs preferencia",
};

function Chain({ ecosystem, chosenHubs }) {
  // egyszerű „lánc” vizuálisan
  const eco = ECO_LABEL[ecosystem] || "Vegyes";
  return (
    <div className="flex items-center gap-2 text-sm flex-wrap">
      <span className="px-2 py-1 rounded bg-gray-100">{eco}</span>
      <span>→</span>
      {chosenHubs.length > 0 ? (
        <>
          {chosenHubs.map((h) => (
            <span key={h.id} className="px-2 py-1 rounded bg-blue-50 border border-blue-200">
              {h.name}
            </span>
          ))}
          <span>→</span>
          <span className="px-2 py-1 rounded bg-gray-100">Zigbee / Wi‑Fi / egyéb eszközök</span>
        </>
      ) : (
        <span className="px-2 py-1 rounded bg-emerald-50 border border-emerald-200">
          App‑only vezérlés
        </span>
      )}
    </div>
  );
}

export default function PlanSummary({
  ecosystem,                   // "apple" | "google" | "alexa" | "mixed"
  hubs = [],                   // összes hub a katalógusból
  selectedHubIds = [],         // kiválasztott hub ID-k
  selectedProducts = [],       // kiválasztott termékek
}) {
  const chosenHubs = useMemo(() => {
    const byId = new Map(hubs.map(h => [h.id, h]));
    return (selectedHubIds || []).map(id => byId.get(id)).filter(Boolean);
  }, [hubs, selectedHubIds]);

  const appList = useMemo(() => {
    // aggregáljuk a szükséges appokat app-only vagy vegyes esetben
    const seen = new Set();
    const out = [];
    for (const p of selectedProducts) {
      const methods = getDirectControlMethods(p);
      for (const m of methods) {
        const key = `${(m.app||"").toLowerCase()}|${(m.protocol||"").toLowerCase()}`;
        if (!key || seen.has(key)) continue;
        seen.add(key);
        out.push(m);
      }
    }
    return out;
  }, [selectedProducts]);

  return (
    <motion.div
      className="bg-white rounded-2xl border border-gray-200 p-4"
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      <h3 className="text-lg font-semibold mb-2">Az Ön rendszerének felépítése</h3>
      <Chain ecosystem={ecosystem} chosenHubs={chosenHubs} />

      {appList.length > 0 && chosenHubs.length === 0 && (
        <div className="mt-3">
          <div className="text-sm font-medium mb-1">Szükséges alkalmazások</div>
          <ul className="list-disc pl-5 text-sm text-gray-700">
            {appList.map((m, i) => (
              <li key={`${m.app}-${m.protocol}-${i}`}>
                {m.app} <span className="text-gray-500">({m.protocol})</span>
              </li>
            ))}
          </ul>
          <p className="text-xs text-gray-500 mt-1">
            Tipp: az appokban lehet szükség gyártói fiókra és az eszközök Wi‑Fi csatlakoztatására.
          </p>
        </div>
      )}
    </motion.div>
  );
}
